import React from 'react';
import styled, { css } from 'styled-components';
import { Box } from '../Box';
import { theme } from '../theme';
import { iconList } from './iconsList';
export const Icon = ({ className = '', render, size = 24, color = 'liquorice', rotate = 0, ...marginProps }) => {
    if (!render || !iconList[render] || render.length === 0)
        return null;
    const IconComponent = iconList[render];
    return (React.createElement(Container, { forwardedAs: "span", "data-testid": `${render}-container`, className: className, size: size, rotate: rotate, color: color, ...marginProps },
        React.createElement(IconComponent, null)));
};
const Container = styled(Box)(({ size, rotate, color }) => css `
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    width: ${size}px;
    height: ${size}px;
    transform: rotate(${rotate}deg);
    svg {
      color: ${theme.colors[color]} !important;
    }
  `);
//# sourceMappingURL=Icon.js.map